import React from 'react';
import {
  Box,
  Typography,
  IconButton,
  Tooltip,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  ToggleButtonGroup,
  ToggleButton,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

const BalanceControls = ({
  showValues,
  onToggleVisibility,
  currency,
  onCurrencyChange,
  viewMode,
  onViewModeChange,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 3,
        flexWrap: 'wrap',
        gap: 2,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Tooltip title={showValues ? 'Ocultar valores' : 'Mostrar valores'}>
          <IconButton
            onClick={onToggleVisibility}
            size="small"
            aria-label={showValues ? 'Ocultar valores' : 'Mostrar valores'}
          >
            {showValues ? <VisibilityIcon /> : <VisibilityOffIcon />}
          </IconButton>
        </Tooltip>
        <Typography
          variant="h5"
          sx={{
            fontWeight: 600,
            color: theme.palette.text.primary,
          }}
        >
          Painel de Saude Financeira
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
        <FormControl size="small" sx={{ minWidth: 100 }}>
          <InputLabel id="currency-select-label">Moeda</InputLabel>
          <Select
            labelId="currency-select-label"
            value={currency}
            label="Moeda"
            onChange={(e) => onCurrencyChange(e.target.value)}
            sx={{
              '& .MuiSelect-select': {
                py: 0.75,
              },
            }}
          >
            <MenuItem value="BRL">BRL (R$)</MenuItem>
            <MenuItem value="USD">USD ($)</MenuItem>
          </Select>
        </FormControl>

        <ToggleButtonGroup
          value={viewMode}
          exclusive
          onChange={(_, value) => value && onViewModeChange(value)}
          size="small"
          aria-label="Periodo de visualizacao"
        >
          <ToggleButton value="monthly" aria-label="Mensal">Mensal</ToggleButton>
          <ToggleButton value="annual" aria-label="Anual">Anual</ToggleButton>
        </ToggleButtonGroup>
      </Box>
    </Box>
  );
};

export default BalanceControls;
